var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1793 26.7516L21.8541 19.1577C22.3676 18.6505 22.6591 17.9514 22.6591 17.2249V3.53127C22.6591 2.02346 21.41 0.789795 19.8834 0.789795H7.40666C6.29639 0.789795 5.29714 1.44775 4.86691 2.44839L0.342539 12.8797C-0.837128 15.5938 1.17524 18.6094 4.15911 18.6094H12.0004L10.682 24.8874C10.5432 25.5727 10.7514 26.2718 11.251 26.7653C12.0698 27.5603 13.3744 27.5603 14.1793 26.7516ZM28.2243 0.789795C26.6977 0.789795 25.4486 2.02346 25.4486 3.53127V14.4972C25.4486 16.005 26.6977 17.2387 28.2243 17.2387C29.7509 17.2387 31 16.005 31 14.4972V3.53127C31 2.02346 29.7509 0.789795 28.2243 0.789795Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeIcon);
export default __webpack_public_path__ + "static/media/dislike-icon.0eb91ddc8ecc4a1d783f8b435eee50f3.svg";
export { ForwardRef as ReactComponent };